import ImportProductsModal, {
	ImportProductsModalProps
} from './ImportProductsModal';

export type { ImportProductsModalProps };
export default ImportProductsModal;
